<template>
  <div>
    <el-table :data="payments" size="small" style="width: 100%" :row-class-name="rowClassName">
      <el-table-column prop="created_at" label="Дата" width="130">
        <template #default="{ row }">
          {{ formatDate(row.created_at) }}
        </template>
      </el-table-column>
      <el-table-column prop="amount" label="Сумма" width="90">
        <template #default="{ row }">
          <span :style="amountStyle(row)" :class="{ 'canceled-amount': row.is_canceled || row.is_canceled == 1 }">
            {{ amountPrefix(row) }}{{ row.amount }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="method" label="Тип оплаты" width="110">
        <template #default="{ row }">
          <span v-if="row.method === 'cash'">Наличные</span>
          <span v-else-if="row.method === 'cashless'">Безнал</span>
          <span v-else-if="row.method === 'abonement'">
            {{ row.direction === 'out' ? 'Абонемент (списание)' : 'Абонемент' }}
          </span>
          <span v-else>{{ row.method }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="comment" label="Комментарий" />
      <el-table-column prop="cancel_reason" label="Причина отмены" />
      <el-table-column label="Действия" width="140">
        <template #default="{ row }">
          <template v-if="!row.is_canceled && row.is_canceled !== 1">
            <el-button type="danger" :icon="Close" size="small" @click="onCancel(row)"/>
            <el-button v-if="row.direction === 'in'" type="warning" :icon="Refresh" size="small" @click="onRefund(row)"/>
          </template>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { Close, Refresh } from '@element-plus/icons-vue'

export default {
  name: 'ClientPayments',
  props: {
    clientId: { type: [String, Number], required: true }
  },
  emits: ['abonement-updated'],
  data() {
    return {
    }
  },
  computed:{
    Close() {
      return Close
    },
    Refresh() {
      return Refresh
    },
    ...mapState('payments', ['payments'])
  },
  mounted() {
    if(this.clientId){
      this.fetchPayments({client_id: this.clientId})
    }
  },
  methods: {
    ...mapActions('payments', ['fetchPayments', 'refundPayment', 'cancelPayment']),
    ...mapActions('abonements', ['getAbonements']),
    formatDate(ts) {
      if (!ts) return ''
      const date = new Date(String(ts).length === 10 ? ts * 1000 : Number(ts))
      return date.toLocaleString('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
    },
    rowClassName({ row }) {
      return row.is_canceled || row.is_canceled == 1 ? 'is-canceled' : ''
    },
    amountPrefix(row) {
      if (row.direction === 'in') return '+'
      if (row.direction === 'out') return ''
      return ''
    },
    amountStyle(row) {
      if (row.is_canceled || row.is_canceled == 1) {
        return { color: '#aaa' }
      }
      if (row.direction === 'in') {
        return { color: 'green' }
      }
      if (row.direction === 'out') {
        return { color: 'red' }
      }
      return {}
    },
    async onCancel(row) {
      try {
        const { value: comment } = await this.$prompt('Пожалуйста, укажите причину отмены платежа:', 'Подтверждение', {
          confirmButtonText: 'Р”Р°',
          cancelButtonText: 'Нет',
          inputPattern: /.+/,
          inputErrorMessage: 'Причина не может быть пустой',
          inputPlaceholder: 'Введите причину'
        })
        await this.cancelPayment({
          payment_id: row.id,
          client_id: this.clientId,
          amount: row.amount,
          comment: comment,
          origin: row.origin // передаём источник (payments или client_balance_operations)
        })
        this.$message({ type: 'success', message: 'Платеж отменён' })
        this.$emit('abonement-updated');
        if(row.origin === 'client_balance_operations'){
          await this.getAbonements({ client_id: this.clientId })
        }
      } catch (e) {
        // отмена действия или ошибка
      }
    },
    async onRefund(row) {
      try {
        const { value: comment } = await this.$prompt('Пожалуйста, укажите причину возврата платежа:', 'Подтверждение', {
          confirmButtonText: 'Р”Р°',
          cancelButtonText: 'Нет',
          inputPattern: /.+/,
          inputErrorMessage: 'Причина не может быть пустой',
          inputPlaceholder: 'Введите причину'
        })
        await this.refundPayment({ payment_id: row.id, client_id: this.clientId, amount: row.amount, comment })
        this.$message({ type: 'success', message: 'Возврат выполнен' })
        this.$emit('abonement-updated');
      } catch (e) {
        // отмена действия или ошибка
      }
    }
  }
}
</script>

<style>
.is-canceled {
  text-decoration: line-through;
  color: #aaa;
}

.client-form-tab-panel .el-table,
.client-form-tab-panel .el-table__inner-wrapper,
.client-form-tab-panel .el-table__header-wrapper,
.client-form-tab-panel .el-table__body-wrapper,
.client-form-tab-panel .el-table__empty-block,
.client-form-tab-panel .el-table__empty-text,
.client-form-tab-panel .el-table__header,
.client-form-tab-panel .el-table__body,
.client-form-tab-panel .el-table tr,
.client-form-tab-panel .el-table th.el-table__cell,
.client-form-tab-panel .el-table td.el-table__cell {
  background: transparent !important;
  --el-table-bg-color: transparent;
  --el-table-tr-bg-color: transparent;
  --el-table-row-hover-bg-color: transparent;
  --el-table-header-bg-color: transparent;
  --el-table-border-color: rgba(91, 130, 202, 0.24);
}

.client-form-tab-panel .el-table::before,
.client-form-tab-panel .el-table__inner-wrapper::before {
  display: none !important;
}

.client-form-tab-panel .el-table__empty-text,
.client-form-tab-panel .el-table th.el-table__cell .cell,
.client-form-tab-panel .el-table td.el-table__cell .cell,
.client-form-tab-panel .el-table .cell {
  color: #d7e7ff !important;
  font-family: var(--ui-font-family-base) !important;
  font-weight: 300 !important;
}

.client-form-tab-panel .el-table th.el-table__cell,
.client-form-tab-panel .el-table td.el-table__cell {
  border-bottom-color: rgba(91, 130, 202, 0.2) !important;
}
</style>

